module.exports = __webpack_public_path__ + "img/서울대입구역 카페.2a203c89.png";